import { USER_ROLES } from '../utils/utils';
import { useUserStoreDefinition } from '~/store/user';

export default function ({ redirect, app }) {
  const userStore = useUserStoreDefinition(app.pinia);
  if (
    process.client &&
    userStore.getOrgsWithPerms(USER_ROLES.EVENT_MANAGEMENT.permissions)
      .length === 0
  ) {
    return redirect('/');
  }
}
